<template>
  <div>
    <!-- 用户信息区域和订单统计区域同一行 -->
    <div class="top-section">
      <!-- 用户信息区域 -->
      <div class="user-info-section">
        <div class="user-avatar">
          <img :src="userInfo.avatar" alt="用户头像" v-if="isLoggedIn">
          <img src="@/assets/images/6.png" alt="用户头像" v-else>
        </div>
        <div class="user-details">
          <div class="username" v-if="isLoggedIn">{{ userInfo.nickname }}</div>
          <div class="username" v-else>请登录</div>
          <!-- <div class="user-id">ID: 1541215412</div> -->
        </div>
        <div class="editBtn" @click="handleEditClick">
          <img src="@/assets/images/50.png" alt="" class="edit-icon">
          <span>修改</span>
        </div>
      </div>

      <!-- 订单统计区域 -->
      <div class="order-section">
        <div class="section-title">我的订单</div>
        <div class="order-stats">
          <div class="stat-item">
            <div class="stat-number">{{ orderNum.no_pay }}</div>
            <div class="stat-label">待付款</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">{{ orderNum.deliver }}</div>
            <div class="stat-label">待发货</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">{{ orderNum.receiv }}</div>
            <div class="stat-label">待收货</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">{{ orderNum.evaluate }}</div>
            <div class="stat-label">待评价</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">{{ orderNum.refund }}</div>
            <div class="stat-label">退款/售后</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 热门推荐区域 -->
    <div class="recommendation-section">
      <div class="section-header">
        <div class="headerLeft">
          <span class="line"></span>
          热门推荐
        </div>
        <!-- <div class="view-more">
          <router-link to="/more-products">查看更多商品>></router-link>
        </div> -->
      </div>
      <div class="products-grid">
        <div class="product-card" v-for="(product, index) in hotProducts" :key="index" @click="goShopDetails(product)">
          <div class="product-image">
            <img :src="product.thumb" :alt="product.name">
          </div>
          <div class="product-info">
            <div class="product-name">{{ product.name }}</div>
            <div class="product-price">
              <span class="price-symbol">¥</span>
              <span class="price-value">{{ product.shop_price }}</span>
              <span class="price-unit">/{{ product.unit }}</span>
            </div>
            <div class="product-sales">销量{{ product.sales_sum }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonalInfo',
  data() {
    return {
      orderNum: {},
      hotProducts: [

      ]
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    userInfo() {
      return this.$store.getters.getUserInfo;
    }
  },

  mounted() {
    console.log(this.isLoggedIn);
    console.log(this.userInfo);
    this.getOrderRedDotCount();
    this.getHotRecommend();
  },
  methods: {
    // 处理修改按钮点击事件
    handleEditClick() {
      this.$parent.currentComponent = 'EditInfo'
    },

    // 处理商品点击事件
    goShopDetails(product) {
      this.$router.push({
        path: '/ShopDetails',
        query: {
          id: product.id
        }
      })
    },

    // 获取订单红点数量
    getOrderRedDotCount() {
      this.$api.getOrderRedDotCount().then(res => {
        this.orderNum = res;
      }).catch(err => {
        this.$message.error(err);
      });
    },
    // 获取热门推荐
    getHotRecommend() {
      this.$api.getHotRecommend().then(res => {
        this.hotProducts = res;
      }).catch(err => {
        this.$message.error(err);
      });
    }



  }
}
</script>

<style scoped>
.member-center {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  padding: 20px;
}

/* 顶部区域 - 用户信息和订单统计同一行 */
.top-section {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 20px;
  margin-bottom: 20px;
}

/* 用户信息区域 - 内部上下分布 */
.user-info-section {
  background: url('~@/assets/images/51.png') no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 240px;
  color: #ffffff;
  position: relative;
}

.user-avatar {
  margin-bottom: 15px;
}

.user-avatar img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.user-details {
  margin-bottom: 20px;
}

.username {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 5px;
}

.user-id {
  font-size: 14px;
  opacity: 0.9;
}

.editBtn {
  width: 74px;
  height: 28px;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.15) 0%, #000000 100%);
  border-radius: 4px 4px 4px 16px;
  opacity: 0.48;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0px;
  right: 0px;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  cursor: pointer;
}

.edit-icon {
  width: 14px;
  height: 14px;
  margin-right: 4px;
}



/* 订单统计区域 */
.order-section {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 24px;
  flex: 1;
  border: 1px solid #f0f0f0;
}

.section-title {
  text-align: left;
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  padding-bottom: 20px;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 25px;
}

.order-stats {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.stat-number {
  font-size: 28px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 16px;
}

.stat-label {
  font-size: 14px;
  color: #666666;
}

/* 热门推荐区域 */
.recommendation-section {
  margin-bottom: 20px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.view-more a {
  font-size: 14px;
  color: #666666;
  text-decoration: none;
}

.view-more a:hover {
  color: #286CED;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.product-card {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.product-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.product-image {
  width: 100%;
  height: 180px;
  overflow: hidden;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.product-card:hover .product-image img {
  transform: scale(1.05);
}

.product-info {
  padding: 12px;
  text-align: left;
}

.product-name {
  font-size: 14px;
  color: #333333;
  margin-bottom: 10px;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.product-price {
  font-size: 16px;
  color: #ff4d4f;
  font-weight: 600;
  margin-bottom: 5px;
}

.price-symbol {
  font-size: 12px;
}

.price-unit {
  font-size: 12px;
  margin-left: 2px;
}

.product-sales {
  font-size: 12px;
  color: #999999;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .top-section {
    flex-direction: column;
  }

  .products-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .order-stats {
    flex-wrap: wrap;
  }

  .stat-item {
    flex: 1 1 50%;
    margin-bottom: 15px;
  }
}

.headerLeft {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  color: #333333;
}

.line {
  display: block;
  width: 4px;
  height: 18px;
  background-color: #286CED;
  border-radius: 2px;
  margin-right: 12px;
}
</style>